export function contentPredicate(keys) {
  return (data) => keys.every((k) => data[k]);
}
